function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    rx: 6,
    ry: 6,
    style: {
      fill: "#6e95ff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.78,14.42h-2.55c-2.47,0-3.63-1.27-3.63-3.98v-2.86c0-2.75,1.12-3.98,3.63-3.98h2.55c2.51,0,3.63,1.23,3.63,3.98v2.86c0,2.75-1.12,3.98-3.63,3.98Zm-2.55-9.53c-1.54,0-2.33,.42-2.33,2.68v2.86c0,2.27,.78,2.68,2.33,2.68h2.55c1.54,0,2.33-.42,2.33-2.68v-2.86c0-2.27-.78-2.68-2.33-2.68h-2.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.09,8.22h-3.19c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h3.19c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.09,11.08h-3.19c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h3.19c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.93,8.11l-.43,.47c-.86-.15-1.55-.79-1.72-1.65l.43-.46c.26-.29,.53-.48,.84-.48,.25,0,.53,.13,.85,.43,.72,.68,.54,1.16,.04,1.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.03,9.08l-2.36,2.5c-.08,.08-.28,.18-.39,.2l-1.28,.22c-.13,.02-.23,0-.31-.07-.07-.06-.11-.17-.08-.31l.15-1.28c.01-.12,.11-.32,.18-.4l2.36-2.5c.3,.78,.93,1.39,1.74,1.64Z",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteEdit);
export default __webpack_public_path__ + "static/media/note_edit.30883572e86e74eced4289d0a32dbf5f.svg";
export { ForwardRef as ReactComponent };